import "@angular/compiler";
import { hRoutes } from "@core/classes/h-routes/h-routes";
import { TeamLiveReportsRoutes } from "@hmodules/team-live/reports/team-live_reports.routes";
import { EngagementSurveysRoutes } from "@ngmodules/engagement-surveys/engagement-surveys.routes";
import { TeamLiveScheduleRoutes } from "@hmodules/team-live/schedule/team-live_schedule.routes";
import { enableProdMode } from "@angular/core";
import { LMSRoutes } from "@hmodules/lms/LMS.routes";
import { JobTemplatesRoutes } from "@ngmodules/job-templates/job-templates.routes";
import * as angular from "angular";
import { PmsRoutes } from "@ngmodules/pms/pms.routes";
import { TlSettingsEmployerRoutes } from "@ngmodules/teamlive-settings/tl-settings-employer.routes";
import { AdamRoutes } from "@ngmodules/adam/adam.routes";
import { LogbookRoutes } from "@ngmodules/logbook/logbook.routes";
import { LogbookEnterpriseRoutes } from "@ngmodules/logbook/logbook-enterprise.routes";
import { getCommunicationHubRoutes } from "@ngmodules/communication-hub/communication-hub.routes";
import { PeoplePlatformRoutes, PeoplePlatformTLRoutes } from "@ngmodules/people-platform/people-platform.routes";
import { OnBoardingJourneyRoutes } from "@ngmodules/on-boarding-journey/on-boarding-journey.routes";
import { GoodFaithEstimateRoutes } from "@ngmodules/good-faith-estimate/good-faith-estimate.routes";
import { AdminEmploymentProfileRoutes } from "@ngmodules/admin-employment-profile/admin-employment-profile.routes";
import { RegistrationRoutes } from "@ngmodules/registration/registration.routes";
import { RecruitmentHubRoutes } from "@ngmodules/recruitment-hub/recruitment-hub.routes";
import { LiveScheduleAccessRoutes, LiveScheduleAccessTLRoutes } from "@ngmodules/live-schedule-access/live-schedule-access.routes";
import { BillingRoutes } from "@ngmodules/billing/billing.routes";
import { OnboardingManagersNotificationsRoutes } from "@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.routes";
import { PayRunsRoutes } from "@ngmodules/pay-runs/pay-runs.routes";
import { EmployeeNotesRoutes } from "@ngmodules/employee-notes/employee-notes.routes";
import { HrActionsTemplatesRoutes } from "@ngmodules/hr-actions-templates/hr-actions-templates.routes";
import { JobApprovalRoutes } from "@ngmodules/job-approval/job-approval.routes";
import { HmapSettingsRoutes } from "@ngmodules/settings/hmap-settings.routes";
import { CustomDocsRoutes } from "@ngmodules/custom-docs/custom-docs.routes";
import { LightCommunicationHubRoutes } from "@ngmodules/light-communication-hub/light-communication-hub.routes";
import { TwoFactorAuthRoutes } from "@ngmodules/two-factor-auth/two-factor-auth.routes";
import { JobCreateRoute } from "@ngmodules/job-create/job-create.routes";
import { TemplatesManagementRoutes } from "@ngmodules/templates-management/templates-management.routes";
import { MiceRoutes } from "@ngmodules/mice/mice.routes";
import { EeoQuestionsSettingsRoutes } from "@ngmodules/eeo-questions-settings/eeo-questions-settings.routes";
import { RestrictedPositionRoutes } from "@ngmodules/restricted-position/restricted-position.routes";
import { IndeedCampaignsRoutes } from "@ngmodules/indeed-campaigns/indeed-capaigns.routes";
import { LmsRoutes } from "@ngmodules/lms/lms.routes";
import { DeleteAccountRoutes } from "@ngmodules/delete-account/delete-account.routes";
import { EmployeeJobsRoutes } from "@ngmodules/employee-jobs/employee-jobs.routes";
import { TeamliveRequestsEmployerRoutes } from "@ngmodules/teamlive-requests/teamlive-requests-employer.routes";
import { EmailAddressChangeRoutes } from "@ngmodules/email-address-change/email-address-change.routes";
import { FinalFwwRoutes } from "@ngmodules/final-fww/final-fww.routes";
import { RegularScheduleVariationsRoutes } from "@ngmodules/regular-schedule-variations/regular-schedule-variations.routes";
import { OnboardingVideoRoutes } from "@ngmodules/onboarding-video/onboarding-video.routes";
import { ScheduleChangeConsentEmployerRoutes } from "@ngmodules/schedule-change-consent/schedule-change-consent-employer.routes";
import { ManageCarriPositionsRoutes } from "@ngmodules/carri/manage-carri-positions/manage-carri-positions.routes";
import { ReportsRoutes } from "@ngmodules/reports/reports.routes";
import { MiscellaneousPaymentRoutes } from "@ngmodules/miscellaneous-payment/miscellaneous-payment.routes";
import { LiveWireRoutes } from "@ngmodules/live-wire/live-wire.routes";
import { CustomSourcesRoutes } from "@ngmodules/custom-sources/custom-sources.routes";
import { HarriEngageRoutes } from "@ngmodules/harri-engage/harri-engage.routes";
import { HMAPRoutes } from "@ngmodules/hmap/hmap.routes";
import { ShiftTradeEmployerRoutes } from "@ngmodules/shift-trade/shift-trade-employer.routes";
import { TerminationEngagementRoutes } from "@ngmodules/termination-engagement/termination-engagement.routes";
import { PermissionManagementRoutes } from "@ngmodules/permission-management/permission-management.routes";
import { TipsDistributionBulkRoutes } from "@ngmodules/tips-distribution/tips-distribution-bulk/tips-distribution-bulk.routes";
import { DashboardsRoutes } from "@ngmodules/dashboards/dashboards.routes";
import { TeamliveSettingsAuditRoutes } from "@ngmodules/teamlive-settings-audit/teamlive-settings-audit.routes";
import { ActivityBasedSchedulingRoutes } from "@ngmodules/activity-based-scheduling/activity-based-scheduling.routes";
import { IpcPortalRoutes } from "@ngmodules/ipc-portal/ipc-portal.routes";
import { CrmRoutes } from "@ngmodules/crm/crm.routes";
import { BreakWaiverRoutes } from "@ngmodules/break-waivers/break-waiver.routes";
import { InterviewInviteRoutes } from "@ngmodules/interview-invite/interview-invite.routes";
import { BulkJobPostRoutes } from "@ngmodules/bulk-job-post/bulk-job-post.routes";
import { CareerStoryPageManagerRoutes } from "@ngmodules/career-story-page-manger/career-story-page-manger.routes";
import { AutomatedOnboardingRoutes } from "@ngmodules/onboarding-automation/automated-onboarding.routes";
import { HuiRoutes } from "@ngmodules/hui/hui.routes";
import { ReportsManagementRoutes } from "@ngmodules/reports-management/reports-management.routes";
let host = environmentsConfig.getEnv().host;
hRoutes.register(LiveScheduleAccessRoutes);
hRoutes.register(AdamRoutes);
hRoutes.register(TlSettingsEmployerRoutes);
hRoutes.register(LiveScheduleAccessTLRoutes);
hRoutes.register(TeamLiveReportsRoutes);
hRoutes.register(EngagementSurveysRoutes);
hRoutes.register(TeamLiveScheduleRoutes);
hRoutes.register(LMSRoutes);
hRoutes.register(JobTemplatesRoutes);
hRoutes.register(PayRunsRoutes);
hRoutes.register(OnboardingManagersNotificationsRoutes);
hRoutes.register(CrmRoutes);
hRoutes.register(CareerStoryPageManagerRoutes);
hRoutes.register(AutomatedOnboardingRoutes);
hRoutes.register(EmployeeNotesRoutes);
hRoutes.register(AdminEmploymentProfileRoutes);
hRoutes.register(PmsRoutes);
hRoutes.register(LogbookRoutes);
hRoutes.register(LogbookEnterpriseRoutes);
hRoutes.register(getCommunicationHubRoutes());
hRoutes.register(PeoplePlatformRoutes);
hRoutes.register(HuiRoutes);
hRoutes.register(LightCommunicationHubRoutes);
hRoutes.register(OnBoardingJourneyRoutes);
hRoutes.register(PeoplePlatformTLRoutes);
hRoutes.register(EeoQuestionsSettingsRoutes);
hRoutes.register(ScheduleChangeConsentEmployerRoutes);
hRoutes.register(TeamliveRequestsEmployerRoutes);
hRoutes.register(GoodFaithEstimateRoutes);
hRoutes.register(ShiftTradeEmployerRoutes);
hRoutes.register(RegistrationRoutes);
hRoutes.register(RecruitmentHubRoutes);
hRoutes.register(BillingRoutes);
hRoutes.register(HrActionsTemplatesRoutes);
hRoutes.register(CustomSourcesRoutes);
hRoutes.register(JobApprovalRoutes);
hRoutes.register(HmapSettingsRoutes);
hRoutes.register(LiveWireRoutes);
hRoutes.register(MiceRoutes);
hRoutes.register(RestrictedPositionRoutes);
hRoutes.register(ActivityBasedSchedulingRoutes);
hRoutes.register(OnboardingVideoRoutes);
hRoutes.register(CustomDocsRoutes);
hRoutes.register(JobCreateRoute);
hRoutes.register(TwoFactorAuthRoutes);
hRoutes.register(TerminationEngagementRoutes);
hRoutes.register(TemplatesManagementRoutes);
hRoutes.register(IndeedCampaignsRoutes);
hRoutes.register(ReportsRoutes);
hRoutes.register(ReportsManagementRoutes);
hRoutes.register(DashboardsRoutes);
hRoutes.register(LmsRoutes);
hRoutes.register(DeleteAccountRoutes);
hRoutes.register(ManageCarriPositionsRoutes);
hRoutes.register(RegularScheduleVariationsRoutes);
hRoutes.register(EmployeeJobsRoutes);
hRoutes.register(EmailAddressChangeRoutes);
hRoutes.register(FinalFwwRoutes);
hRoutes.register(MiscellaneousPaymentRoutes);
hRoutes.register(HarriEngageRoutes);
hRoutes.register(HMAPRoutes);
hRoutes.register(PermissionManagementRoutes);
hRoutes.register(TeamliveSettingsAuditRoutes);
hRoutes.register(TipsDistributionBulkRoutes);
hRoutes.register(IpcPortalRoutes);
hRoutes.register(BreakWaiverRoutes);
hRoutes.register(BulkJobPostRoutes);
hRoutes.register(InterviewInviteRoutes);
if (CDNUri) {
    enableProdMode();
}
if (["harri" /* APP_HOST.HARRI */, "harridev" /* APP_HOST.HARRI_DEV */, "harristaging" /* APP_HOST.HARRI_STAGING */, "harriuat" /* APP_HOST.HARRI_UAT */, "harribeta" /* APP_HOST.HARRI_BETA */, "harriprep" /* APP_HOST.HARRI_PREP */].indexOf(host) > -1) {
    angular.bootstrap(document.body, ['harriMainApp'], { strictDi: true });
}
else {
    angular.bootstrap(document.body, ['teamLiveApp'], { strictDi: true });
}
//# sourceMappingURL=harri.js.map